import React, { Fragment, useEffect } from "react";
import { MapContainer, TileLayer, useMap, ZoomControl } from "react-leaflet";
import ParkingLots from "./ParkingLots";
import { HandicapSpaces, ElecSpaces } from "./ParkingSpaces";
import { createHandicapClusterIcon, createElectricClusterIcon } from "../lib/CustomIcons";
import MarkerClusterGroup from "react-leaflet-cluster";
import Media from 'react-media';
import getParam from '../lib/MapParam';
import { Dropdown } from "./Overlay";
import { Appstore } from "./Appstore";

function MapListener() {
  const map = useMap();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (map && map.getContainer()) {
        map.invalidateSize();
      }
    }, 250);

    return () => clearTimeout(timeout);
  }, [map]);

  return null;
}

function buildMap(screenSize: "mobile" | "tablet" | "laptop" | "desktop" | "tv") {
  const param = getParam(screenSize);

  return <MapContainer
    id="mapId"
    zoom={param.zoomFromUrl}
    center={param.centerFromUrl}
    maxBounds={param.boundsFromUrl}
    maxBoundsViscosity={1}
    maxZoom={param.maxZoom}
    minZoom={param.minZoom}
    attributionControl={false}
    zoomControl={false}
  >
    
    {screenSize !== "mobile" && <ZoomControl position="topright" />}

    <MapListener />
    <TileLayer
      url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
      maxZoom={22} />

    <ParkingLots />

    <div className="leaflet-top leaflet-left">
      <div className="leaflet-control leaflet-bar">
        <Dropdown />
      </div>
    </div>

    <div className="leaflet-bottom leaflet-left">
      <div className="leaflet-control leaflet-bar">
        <Appstore screenSize={screenSize}/>
      </div>
    </div>

    <MarkerClusterGroup
      chunkedLoading
      iconCreateFunction={createHandicapClusterIcon}
      maxClusterRadius={30}
      showCoverageOnHover={false}
      disableClusteringAtZoom={19}
      spiderfyOnMaxZoom={false}
    >
      <HandicapSpaces />
    </MarkerClusterGroup>
    <MarkerClusterGroup
      chunkedLoading
      iconCreateFunction={createElectricClusterIcon}
      maxClusterRadius={30}
      showCoverageOnHover={false}
      disableClusteringAtZoom={19}
      spiderfyOnMaxZoom={false}
    >
      <ElecSpaces />
    </MarkerClusterGroup>

  </MapContainer>
}

function Map(props) {
  //const [map, setMap] = useState(null);
  return (
    <Media queries={{
      mobile: "(max-width: 480px)",
      tablet: "(min-width: 481px) and (max-width: 768px)",
      laptop: "(min-width: 769px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px) and (max-width: 1200px)",
      tv: "(min-width: 1201px)"
    }}>
      {matches => (
        <Fragment>
          {matches.mobile && buildMap("mobile")}
          {matches.tablet && buildMap("tablet")}
          {matches.laptop && buildMap("laptop")}
          {matches.desktop && buildMap("desktop")}
          {matches.tv && buildMap("tv")}
        </Fragment>
      )}
    </Media>
  )
};

export default Map;
